import { Mail } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { CONTACT_EMAIL } from "../i18n/translations";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import IntakeForm from "../components/IntakeForm";

export default function Contact() {
  const { t } = useLanguage();
  const c = t.contactPage;

  return (
    <>
      <Seo title={c.seoTitle} description={c.seoDesc} />

      <section className="pt-16 pb-20 md:py-28 relative overflow-hidden" data-testid="contact-page">
        <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full bg-gold/5 blur-3xl pointer-events-none d1-drift" />
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-12 gap-12">
          {/* Left rail */}
          <div className="md:col-span-5">
            <span className="text-xs font-mono uppercase tracking-widest text-gold">{c.eyebrow}</span>
            <h1 className="font-display uppercase text-4xl sm:text-5xl tracking-tight text-white mt-2 mb-8" data-testid="contact-page-title">
              <span className="ln"><span>{c.title}</span></span>
            </h1>
            <p className="text-base text-bone-soft leading-relaxed mb-10">{c.lead}</p>

            <div className="bg-coal-card p-6 rounded-lg border border-line-subtle mb-6" data-testid="contact-email-card">
              <div className="text-xs font-mono uppercase tracking-widest text-gold-dim mb-1">
                {c.emailCardLabel}
              </div>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="inline-flex items-center gap-2 text-sm font-mono text-white break-all select-all font-medium hover:text-gold transition-colors"
                data-testid="contact-email-link"
              >
                <Mail className="w-4 h-4 shrink-0" />
                {CONTACT_EMAIL}
              </a>
            </div>

            <div className="bg-coal-card p-6 rounded-lg border border-line-subtle" data-testid="contact-expect-card">
              <div className="text-xs font-mono uppercase tracking-widest text-gold-dim mb-3">
                {c.expectTitle}
              </div>
              <ul className="space-y-2 text-sm text-bone-soft">
                {c.expect.map((item) => (
                  <li key={item} className="flex gap-2">
                    <span className="text-gold mt-0.5" aria-hidden="true">&bull;</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Form */}
          <Reveal className="md:col-span-7" delay={120}>
            <IntakeForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
